import { Button, ButtonGroup, Grid2 } from "@mui/material";
import { useState } from "react";

export default function TimeButtons({ buttons }) {
  const [buttonSelected, setButtonSelected] = useState(0);

  return (
    <Grid2 container={true} justifyContent={'center'} alignItems={'center'} direction={'row'} spacing={4} gap={1} id={"TimeButtonsGrid"}>
      <ButtonGroup>
        {buttons.map((button, key) => (
          <Button
            key={key}
            onClick={() => setButtonSelected(key)}
            variant={buttonSelected === key ? "contained" : "outlined"}
          >
            {button}
          </Button>
        ))}
      </ButtonGroup>
      <Button variant="contained">Generate Report</Button>
    </Grid2>
  );
}
